import { jsx } from "react/jsx-runtime";
import React from "react";
import { node, string, oneOfType, arrayOf } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** Prefix all classes in every element with this string, [Inherited] */
  prefix: string,
  children: oneOfType([
    arrayOf(node),
    node
  ]),
  /** Additional class name to be added to the root element */
  className: string
};
const ModalBody = (props) => {
  const {
    prefix = "",
    children,
    className,
    ...other
  } = props;
  return /* @__PURE__ */ jsx("div", { ...other, className: cx(`${prefix}modal-body`, className), children });
};
ModalBody.propTypes = propTypes;
ModalBody.displayName = "ModalBody";
var ModalBody_default = ModalBody;
export {
  ModalBody_default as default
};
